// export const urlLive = 'https://kamran.com.iclipse-solutions.com/public/api/';

//  local url

// export const url = 'http://127.0.0.1:8000/api/';  
// export const fileUploadUrl = 'http://localhost:8000'; // local file load 
// export const fileUploadUrl = 'http://localhost:8000/api/public';


// live url

export const url = 'https://shareitalents.it/api/';
export const fileUploadUrl = 'https://shareitalents.it/api/public';

// live-skyblue url

// export const url = 'https://skyblue-barracuda-283487.hostingersite.com/api/';
// export const fileUploadUrl = 'https://skyblue-barracuda-283487.hostingersite.com/api/public';
